// extracted by mini-css-extract-plugin
export default {"Contacts":"styles_Contacts__Hs4kC"};